import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RefreshService {
  private resetTableSource = new Subject<void>();
  resetTable$ = this.resetTableSource.asObservable();

  triggerResetTable() {
    this.resetTableSource.next();
  }
  constructor() { }
}
